import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { GetCertificatesTemplate } from "../../../fnx/certificate/getCertificatesTemplate";
import { certificateTemplateClearData, certificateToProjectClearData, deleteCertTemplateClearData, } from "../../../store/certificates/actions";
import { View } from "./view";
import { useNavigate, useParams } from "react-router-dom";
import showToast from "../../../services/toast";
import useTableRows from "../helpers/tableRows";
import useDataCards from "../helpers/dataCards";
import useViewTypes from "../helpers/pageViewTypes";
import usePagination from "../helpers/pagination";
import { useSponsorGetAll } from "../../../fnx/sponsor/sponsorGetAll";
import { GetProjectAll } from "../../../fnx/project/projectAll";
import { projectClearData } from "../../../store/project/actions";
import { sponsorClearData } from "../../../store/sponsor/actions";
import useAssociateProduct from "../helpers/drawerAssociateProduct";
import { PostCertificatesToProject } from "../../../fnx/certificate/certificateToProject";
import { showErrorToast } from "../../../fnx/showError";
import { CertificatesEditorHeader } from "./header";
import { showToastSuccessMessage } from "../../../fnx/sendSuccessMessage";
import useFilters from "../helpers/filters";
import { GetAllSchemasTemplate } from "../../../fnx/certificate/getAllSchemasTemplate";
import useGetMergeFields from "../helpers/getMergeFields";
import { useApiDeleteCertificate } from "../../../fnx/certificate/patchCertTemplate";
import LocalStorageService from "../../../services/localStorage";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var CertificatesPage = function () {
    var created = useParams().created;
    var edited = useParams().edited;
    var userId = React.useState(lsLogin.getUserLoginStored().userId || "")[0];
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = useState([]), dataCards = _a[0], setDataCards = _a[1];
    var _b = React.useState([]), rowsTable = _b[0], setRowsTable = _b[1];
    var _c = React.useState([]), projectList = _c[0], setProjectList = _c[1];
    var _d = React.useState([]), productListDrawer = _d[0], setProductListDrawer = _d[1];
    var _e = React.useState([]), hasProjectList = _e[0], setHasProjectList = _e[1];
    var _f = useState(""), certificateName = _f[0], setCertificateName = _f[1];
    var _g = useState(""), searchProjectId = _g[0], setSearchProjectId = _g[1];
    var _h = useState(""), certType = _h[0], setCertType = _h[1];
    var _j = useState(""), searchTitleCertificate = _j[0], setSearchTitleCertificate = _j[1];
    var _k = React.useState(""), certificateId = _k[0], setCertificateId = _k[1];
    var _l = React.useState(""), projectId = _l[0], setProjectId = _l[1];
    var _m = React.useState(""), sponsorsIds = _m[0], setSponsorsIds = _m[1];
    var _o = useState(false), triggerGetSchemas = _o[0], setTriggerGetSchemas = _o[1];
    var _p = useState(false), openDeleteModal = _p[0], setOpenDeleteModal = _p[1];
    var _q = useState(false), openDrawer = _q[0], setOpenDrawer = _q[1];
    var _r = useState(false), showPagination = _r[0], setShowPagination = _r[1];
    var _s = useState(false), certificateTrigger = _s[0], setCertificateTrigger = _s[1];
    var _t = useState(false), sponsorTrigger = _t[0], setSponsorTrigger = _t[1];
    var _u = React.useState(false), projectTrigger = _u[0], setProjectTrigger = _u[1];
    var _v = React.useState(false), patchTrigger = _v[0], setPatchTrigger = _v[1];
    var _w = React.useState(false), certificateToProjectTrigger = _w[0], setCertificateToProjectTrigger = _w[1];
    var _x = useState(true), enable = _x[0], setEnable = _x[1];
    var _y = useState(0), totalItems = _y[0], setTotalItems = _y[1];
    var _z = useState(24), sponsorLimit = _z[0], setSponsorLimit = _z[1];
    var _0 = useState(24), limit = _0[0], setLimit = _0[1];
    var _1 = useState(1), sponsorPage = _1[0], setSponsorPage = _1[1];
    var _2 = useState(1), page = _2[0], setPage = _2[1];
    var _3 = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _3[0], setSeeToast = _3[1];
    //call-apis
    var _4 = GetCertificatesTemplate(certificateTrigger, enable, page, limit, searchTitleCertificate, searchProjectId, certType), loadingCertificateTemplate = _4.loadingCertificateTemplate, responseCertificateTemplate = _4.responseCertificateTemplate, errorCertificateTemplate = _4.errorCertificateTemplate;
    var _5 = useSponsorGetAll(sponsorTrigger, "", "", sponsorPage, sponsorLimit), loadingSponsor = _5.loadingSponsor, responseSponsor = _5.responseSponsor, errorSponsor = _5.errorSponsor;
    var _6 = GetProjectAll(projectTrigger, enable, sponsorPage, sponsorLimit, sponsorsIds), loadingProject = _6.loadingProject, responseProject = _6.responseProject, errorProject = _6.errorProject;
    var _7 = PostCertificatesToProject(certificateToProjectTrigger, certificateId, projectId), loadingCertificateToProject = _7.loadingCertificateToProject, responseCertificateToProject = _7.responseCertificateToProject, errorCertificateToProject = _7.errorCertificateToProject;
    var _8 = GetAllSchemasTemplate(triggerGetSchemas), loadingSchemasTemplate = _8.loadingSchemasTemplate, responseSchemasTemplate = _8.responseSchemasTemplate, errorSchemasTemplate = _8.errorSchemasTemplate;
    var _9 = useApiDeleteCertificate(patchTrigger, certificateId, userId), loadingPatchCertTemplate = _9.loadingPatchCertTemplate, responsePatchCertTemplate = _9.responsePatchCertTemplate, errorPatchCertTemplate = _9.errorPatchCertTemplate;
    //call-Utils-helpers
    var _10 = useDataCards(setDataCards), setDataCardsList = _10.setDataCardsList, optionsCards = _10.optionsCards;
    var setDataRowsTable = useTableRows(setRowsTable).setDataRowsTable;
    var onClickTypeView = useViewTypes().onClickTypeView;
    var _11 = usePagination(), onChangePage = _11.onChangePage, onChangeItemPerPage = _11.onChangeItemPerPage;
    var listProjects = useAssociateProduct().listProjects;
    var _12 = useFilters(setCertType, setSearchProjectId, setSearchTitleCertificate, setCertificateTrigger), filterCertType = _12.filterCertType, filterProject = _12.filterProject, onChangeFullTextSearch = _12.onChangeFullTextSearch, clearFilter = _12.clearFilter;
    var _13 = useGetMergeFields(), getMergeFields = _13.getMergeFields, mergeFieldsData = _13.mergeFieldsData;
    useEffect(function () {
        setCertificateTrigger(true);
        setSponsorTrigger(true);
        setTriggerGetSchemas(true);
    }, []);
    useEffect(function () {
        sessionStorage.setItem("mergeFieldsData", JSON.stringify(mergeFieldsData));
    }, [mergeFieldsData]);
    useEffect(function () {
        setCertificateTrigger(true);
    }, [certType, searchProjectId, searchTitleCertificate]);
    useEffect(function () {
        var hasShownToast = sessionStorage.getItem("hasShownToast");
        if (!hasShownToast && (created === "true" || edited === "true")) {
            var status = created === "true" ? "created" : "edited";
            showToastSuccessMessage(t("certificatesEditor.".concat(status)), typeAlert.success, setSeeToast);
            sessionStorage.setItem("hasShownToast", "true");
        }
    }, [created, edited]);
    useEffect(function () {
        if (responseCertificateTemplate && responseCertificateTemplate.data) {
            setDataCardsList(responseCertificateTemplate.data); //llena la data de los cards
            setDataRowsTable(responseCertificateTemplate.data); // llena data vista tabla
            if (responseCertificateTemplate.pagingInfo) {
                setTotalItems(responseCertificateTemplate.pagingInfo.totalItems);
            }
            setCertificateTrigger(false);
            dispatch(certificateTemplateClearData());
        }
    }, [responseCertificateTemplate]);
    useEffect(function () {
        setShowPagination(totalItems > limit);
    }, [totalItems]);
    useEffect(function () {
        var _a;
        if (responseSponsor && ((_a = responseSponsor.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var idSponsor = responseSponsor.data
                .map(function (item) { return item.id; })
                .join("&sponsorId=");
            setSponsorsIds(idSponsor);
            setProjectTrigger(true);
            dispatch(sponsorClearData());
        }
    }, [responseSponsor]);
    useEffect(function () {
        if (responseProject === null || responseProject === void 0 ? void 0 : responseProject.data) {
            var _a = listProjects(responseProject.data), drawerProjectList = _a.drawerProjectList, ProjectList = _a.ProjectList;
            setProjectList(ProjectList);
            setProductListDrawer(drawerProjectList);
            dispatch(projectClearData());
            setProjectTrigger(false);
        }
    }, [responseProject]);
    useEffect(function () {
        if (responseCertificateToProject) {
            showToastSuccessMessage(t("certificates.added"), typeAlert.success, setSeeToast);
            setOpenDrawer(false);
            setCertificateTrigger(true);
            setCertificateToProjectTrigger(false);
            dispatch(certificateToProjectClearData());
        }
    }, [responseCertificateToProject]);
    useEffect(function () {
        setProductListDrawer(function (prevList) {
            return prevList.filter(function (product) {
                return !hasProjectList.some(function (project) { return project.id === product.id; });
            });
        });
    }, [hasProjectList]);
    useEffect(function () {
        if (responseSchemasTemplate === null || responseSchemasTemplate === void 0 ? void 0 : responseSchemasTemplate.data) {
            getMergeFields(responseSchemasTemplate.data.schemas);
        }
    }, [responseSchemasTemplate]);
    useEffect(function () {
        if (responsePatchCertTemplate) {
            setOpenDeleteModal(false);
            setCertificateTrigger(true);
            setPatchTrigger(false);
            showToastSuccessMessage(t("certificatesEditor.deleted"), typeAlert.success, setSeeToast);
            dispatch(deleteCertTemplateClearData());
        }
    }, [responsePatchCertTemplate]);
    useEffect(function () {
        if (errorCertificateToProject) {
            showErrorToast(errorCertificateToProject, setSeeToast, t);
            setCertificateToProjectTrigger(false);
            dispatch(certificateToProjectClearData());
        }
    }, [errorCertificateToProject]);
    useEffect(function () {
        if (errorCertificateTemplate) {
            showErrorToast(errorCertificateTemplate, setSeeToast, t);
        }
    }, [errorCertificateTemplate]);
    useEffect(function () {
        if (errorSchemasTemplate) {
            showErrorToast(errorSchemasTemplate, setSeeToast, t);
        }
    }, [errorSchemasTemplate]);
    useEffect(function () {
        if (errorPatchCertTemplate) {
            showErrorToast(errorPatchCertTemplate, setSeeToast, t);
            setOpenDeleteModal(false);
            dispatch(deleteCertTemplateClearData());
        }
    }, [errorPatchCertTemplate]);
    var onClickButtonTypeView = function (option) {
        return onClickTypeView(option, setPage, setCertificateTrigger);
    };
    var optionCard = function (item, data) {
        return optionsCards(item, data, navigate, setCertificateName, setCertificateId, setOpenDeleteModal, setOpenDrawer, setHasProjectList, setPatchTrigger);
    };
    var turnPage = function (page) {
        return onChangePage(setPage, page, setCertificateTrigger);
    };
    var itemPerPage = function (item) {
        return onChangeItemPerPage(setLimit, item, setCertificateTrigger);
    };
    var associateCertificateWithProduct = function (data) {
        var _a;
        setProjectId((_a = data === null || data === void 0 ? void 0 : data.productList) === null || _a === void 0 ? void 0 : _a.id);
        setCertificateToProjectTrigger(true);
        setCertificateTrigger(true);
        setProjectTrigger(true);
        setHasProjectList([]);
        // setCertificateToProjectTrigger(false);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(CertificatesEditorHeader, { loading: loadingCertificateTemplate ||
                    loadingSponsor ||
                    loadingProject ||
                    loadingCertificateToProject ||
                    loadingSchemasTemplate ||
                    loadingPatchCertTemplate, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast }), _jsx(View, { t: t, totalItems: totalItems, page: page, limit: limit, onClickButtonTypeView: onClickButtonTypeView, certificatesList: dataCards, optionCard: optionCard, openDrawer: openDrawer, setOpenDrawer: setOpenDrawer, showPagination: showPagination, onChangePage: turnPage, onChangeRowsPerPage: itemPerPage, rowsTable: rowsTable, openDeleteModal: openDeleteModal, setOpenDeleteModal: setOpenDeleteModal, setProjectTrigger: setProjectTrigger, certificateName: certificateName, projectList: projectList, productListDrawer: productListDrawer, associateCertificateWithProduct: associateCertificateWithProduct, navigate: navigate, filterCertType: filterCertType, clearFilter: clearFilter, filterProject: filterProject, onChangeFullTextSearch: onChangeFullTextSearch, setPatchTrigger: setPatchTrigger })] }));
};
